import {useMemo} from "react";
import {useBackofficeUser} from "../contexts";
import {RolePermissions} from "../declerations/server/role_models";
import {PermissionKey} from "@bounce/shared/enums/permissions";
import {hasPermission} from "@bounce/shared/helpers/permissionUtils";

export const usePermissions = (): RolePermissions => {
  const {rolePermission} = useBackofficeUser();
  return rolePermission ?? [];
};

export const useHasPermission = (permissionKey: PermissionKey): boolean => {
  const permissions = usePermissions();
  return useMemo(() => {
    return hasPermission(permissions ?? [], permissionKey);
  }, [permissions, permissionKey]);
};

export const useCanAssignRE = (): boolean => {
  return useHasPermission(PermissionKey.ACCOUNT_ASSIGN_TO_REX);
};

export const useCanUpdateDisposition = (): boolean => {
  return useHasPermission(PermissionKey.ACCOUNT_UPDATE_DISPOSITION);
};

export const useCanUnmaskCommunications = (): boolean => {
  return useHasPermission(PermissionKey.ACCOUNT_UNMASK_COMMUNICATIONS);
};

export const useHasResolutionExpertsListPermission = (): boolean => {
  const permissions = usePermissions();
  return useMemo(() => {
    const resolutionExpertsListPermissions = [
      PermissionKey.SPRING_CALL_CENTER_CONVERSATIONS,
      PermissionKey.SPRING_TASKS,
      PermissionKey.ACCOUNT_ASSIGN_TO_REX,
    ];
    return resolutionExpertsListPermissions.some((permission) => hasPermission(permissions ?? [], permission));
  }, [permissions]);
};
